"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = expandFlex;

var _js = require("@adeira/js");

var _StyleCollectorNode = _interopRequireDefault(require("../StyleCollectorNode"));

/**
 * 
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/flex
 */
function expandFlex(propertyName, propertyValue) {
  var hashSeed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (typeof propertyValue !== 'string') {
    // could not be expanded
    return [new _StyleCollectorNode.default(propertyName, propertyValue, hashSeed)];
  } // Initial values:
  // - flex-grow: 0
  // - flex-shrink: 1
  // - flex-basis: auto


  var chunks = propertyValue.split(/\s/);

  if (chunks.length === 1) {
    if ((0, _js.isNumeric)(chunks[0])) {
      return [new _StyleCollectorNode.default('flexGrow', chunks[0], hashSeed), new _StyleCollectorNode.default('flexShrink', 1, hashSeed), new _StyleCollectorNode.default('flexBasis', 0, hashSeed)];
    } else if (chunks[0] === 'initial') {
      return [new _StyleCollectorNode.default('flexGrow', 0, hashSeed), new _StyleCollectorNode.default('flexShrink', 1, hashSeed), new _StyleCollectorNode.default('flexBasis', 'auto', hashSeed)];
    } else if (chunks[0] === 'auto') {
      return [new _StyleCollectorNode.default('flexGrow', 1, hashSeed), new _StyleCollectorNode.default('flexShrink', 1, hashSeed), new _StyleCollectorNode.default('flexBasis', 'auto', hashSeed)];
    } else if (chunks[0] === 'none') {
      return [new _StyleCollectorNode.default('flexGrow', 0, hashSeed), new _StyleCollectorNode.default('flexShrink', 0, hashSeed), new _StyleCollectorNode.default('flexBasis', 'auto', hashSeed)];
    }

    return [new _StyleCollectorNode.default('flexGrow', 0, hashSeed), new _StyleCollectorNode.default('flexShrink', 1, hashSeed), new _StyleCollectorNode.default('flexBasis', chunks[0], hashSeed)];
  } else if (chunks.length === 2) {
    if ((0, _js.isNumeric)(chunks[1])) {
      return [new _StyleCollectorNode.default('flexGrow', chunks[0], hashSeed), new _StyleCollectorNode.default('flexShrink', chunks[1], hashSeed), new _StyleCollectorNode.default('flexBasis', 'auto', hashSeed)];
    }

    return [new _StyleCollectorNode.default('flexGrow', chunks[0], hashSeed), new _StyleCollectorNode.default('flexShrink', 1, hashSeed), new _StyleCollectorNode.default('flexBasis', chunks[1], hashSeed)];
  }

  return [new _StyleCollectorNode.default('flexGrow', chunks[0], hashSeed), new _StyleCollectorNode.default('flexShrink', chunks[1], hashSeed), new _StyleCollectorNode.default('flexBasis', chunks[2], hashSeed)];
}